
  import { computed, defineComponent } from 'vue';
  import { router } from '@/ui/routes';
  import { Icon } from '@/ui/components/icon/Icon';
  import { InputField } from '@/ui/components/form/InputField';
  import { Button } from '@/ui/components/Button';
  import { ConfirmationModal } from '@/ui/components/modals/ConfirmationModal';
  import LogoAnchor from '@/ui/components/analytics/LogoAnchor.vue';
  import { useReportInjection } from '@/ui/concerns/analytics/useReportInjection';
  import { useModal } from '@/ui/concerns/modals/useModal';

  interface AnalyticsBuilderHeaderProps {
    titleValue: string;
    hideSave: boolean;
    hideDelete: boolean;
    saveLoading: boolean;
    deleteLoading: boolean;
    saveEnabled: boolean;
    deleteEnabled: boolean;
  }

  export default defineComponent<AnalyticsBuilderHeaderProps>({
    components: {
      LogoAnchor,
      ConfirmationModal,
      Icon,
      InputField,
      Button,
    },
    props: ['titleValue', 'hideDelete', 'hideSave', 'saveLoading', 'deleteLoading', 'saveEnabled', 'deleteEnabled'],
    setup(props, { emit }) {
      const { isGuest } = useReportInjection();
      const [isModalBackOpen, onOpenModalBack, closeModalBack] = useModal();
      const [isModalDeleteOpen, openModalDelete, closeModalDelete] = useModal();
      const isProcessing = computed(() => props.saveLoading || props.deleteLoading);

      const onSave = (quit: boolean) => {
        emit('save', quit);
      };

      const onTitleChange = (title: string) => {
        emit('input-title', title);
      };

      const onConfirmLeavePage = () => router.push({ name: 'analytics-v2' });

      const onDeclineLeavePage = () => closeModalBack();

      const onConfirmDelete = () => {
        emit('delete');
        closeModalDelete();
      };

      const onDeclineDelete = () => closeModalDelete();

      return {
        isGuest,
        isModalBackOpen,
        isModalDeleteOpen,
        isProcessing,
        onOpenModalBack,
        openModalDelete,
        onSave,
        onConfirmLeavePage,
        onDeclineLeavePage,
        onConfirmDelete,
        onDeclineDelete,
        onTitleChange,
      };
    },
  });
